export default {
  新增模板: "Add Template",
  评估物料: "Assessment Material",
  评估阶段: "Assessment Stage",
  评估维度: "Assessment Dimension",
  评估项: "Assessment Item",
  评估物料类别: "Material Category",
  评估阶段_标题: "Assessment Stage",
  取消: "Cancel",
  保存: "Save",
  新增评估阶段: "+ Add Assessment Stage",
  请输入评估物料类别: "Enter material category",
  请完善表单信息: "Please complete the form",
  保存成功: "Saved successfully",
  保存失败: "Save failed",
  加载中: "Loading...",
  序号: "No.",
  评估部门: "Department",
  评估等级: "Grade",
  等级描述: "Description",
  操作: "Action",
  暂无评估项: "No assessment items, click the button below to add",
  添加: "+ Add",
  请输入: "Please enter",
  请选择: "Please select",
  请输入评估项: "Enter assessment item",
  请选择评估部门: "Select department",
  确认删除: "Confirm Delete",
  确定删除模板: "Are you sure you want to delete this assessment template?",
  确定: "Confirm",
  删除成功: "Deleted successfully",
  删除失败: "Delete failed",
  删除维度: "Delete Dimension",
  请输入评估维度: "Enter assessment dimension",
  评估阶段_占位符: "Assessment Stage",
  删除阶段: "Delete Stage",
  新增维度: "+ Add Dimension",
  请输入评估阶段: "Enter assessment stage",
  评估标准: "Assessment Standard",
  等级: "Grade",
  描述: "Description",
  评估部门_表头: "Department",
};
